<template>
  <div class="content">
    <div class="head">
      <img src="../assets/btn.png" alt="" class="btn" @click="showOverlay" />
      <img src="../assets/btn1.png" alt="" class="btn1" @click="showUnavailableMessage" />
    </div>
    <div class="body1">
      <img src="../assets/body1.png" alt="">
    </div>
    <div class="body2">
      <div class="swiper-container">
        <div class="swiper-wrapper">
          <div class="swiper-slide" v-for="(item, index) in swiperList" :key="index">
            <img :src="item.img" alt="">
          </div>
        </div>
      </div>
    </div>
    <div class="footer">
      <img src="../assets/footer.png" alt="">
    </div>
    <div v-if="isOverlayVisible" id="overlay" class="overlay" @click.self="hideOverlay">
      <div class="popup">

      </div>
    </div>
  </div>
</template>
<script>
import Swiper from 'swiper';
import 'swiper/css/swiper.min.css'
export default {
  data() {
    return {
      swiper: null,
      isOverlayVisible: false,
      swiperList: [
        {
          img: require('../assets/swiper1.png')
        },
        {
          img: require('../assets/swiper2.png')
        },
        {
          img: require('../assets/swiper3.png')
        }
      ]
    }
  },
  mounted() {
    this.initSwiper()
  },
  methods: {
    initSwiper() {
      this.swiper = new Swiper('.swiper-container', {
        loop: true, //循环
        autoplay: {
          delay: 5000, //自动切换时间
          disableOnInteraction: false //是否禁止用户操作时停止自动切换
        },
        paginationClick: true, //点击分页器切换
        slidesPerView: 1, //每页显示个数
        spaceBetween: 0, //分页器间距

      })
    },
    showOverlay() {
      window.location.href = "https://recruit-1688.obs.cn-southwest-2.myhuaweicloud.com/recruit/app/110.apk";
      // this.isOverlayVisible = true;
    },
    hideOverlay() {
      this.isOverlayVisible = false;
    },
    showUnavailableMessage() {
      location.href = 'https://apps.apple.com/cn/app/%E7%8C%AA%E7%8C%AA%E5%B0%8F%E5%B8%AE%E6%89%8B/id6739935416'
    }
  }

}
</script>
<style scoped>
.content {
  width: 100%;
  height: 100%;
  padding: 0;
  margin: 0;
}

.content .head {
  width: 100%;
  height: 1800px;
  background: url(../assets/head.png) no-repeat;
  background-size: 100% 100%;
  position: relative;
}

.content .head .btn {
  width: 680px;
  position: absolute;
  bottom: 226px;
  left: 135px;
  cursor: pointer;
}

.content .head .btn1 {
  width: 680px;
  position: absolute;
  bottom: 86px;
  left: 135px;
}

.body1 {
  width: 100%;
  display: flex;
  justify-content: center;
}

.body2 {
  width: 100%;
  height: 1680px;
  background: url(../assets/body2.png) no-repeat;
  background-size: 100% 100%;
  position: relative;
}

.swiper-wrapper {
  display: flex;
  width: 406px;
  height: 1080px;
  margin-top: 475px;
}


/* 隐藏遮罩层 */
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8);
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

/* 弹出窗口的样式 */
.popup {
  padding: 20px;
  border-radius: 5px;
  text-align: center;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
}

.popup img {
  max-width: 100%;
  height: auto;
}

.popup button {
  margin-top: 10px;
  padding: 5px 10px;
  background-color: #007BFF;
  color: white;
  border: none;
  border-radius: 3px;
  cursor: pointer;
}


.swiper-pagination-bullet {
  width: 20px;
  height: 20px;
}

.swiper-slide {
  display: flex;
  justify-content: center;
}

.footer {
  width: 100%;
}

.footer img {
  width: 100%;
}
</style>
